<button
  type="button"
  class="column-visibility-button"
  [class.active]="isColumnPanelOpen()"
  (click)="toggleColumnPanel()"
  [attr.aria-label]="label"
  [attr.aria-pressed]="isColumnPanelOpen()"
>
  @if (showIcon) {
    <span class="button-icon" aria-hidden="true">☰</span>
  }
  <span class="button-label">{{ label }}</span>
</button>
